import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import "bootstrap-icons/font/bootstrap-icons.css";
import './core/css/global.css';
import './assets/index.css';
import { register } from './serviceWorkerRegistration';

// Apply saved theme immediately to prevent flash
const savedTheme = localStorage.getItem('ntcog-theme') as 'light' | 'dark' | 'system' | null;
if (savedTheme && savedTheme !== 'light') {
  const resolved = savedTheme === 'system'
    ? (window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light')
    : savedTheme;
  document.documentElement.setAttribute('data-bs-theme', resolved);
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

register();